<div class="member-badge" [ngClass]="role" [style]="customStyle">
  <div class="texture"></div>
  <div class="member-details">
    <div class="wwm-icon"></div>
    @if (userService.me && showUsername) {
      <div class="member-name">{{ userService.me.firstName }} {{ userService.me.lastName }}</div>
    }
    @if (!showUsername) {
      <div class="member-name">{{ userService.me?.memberRole?.roleName }} Membership</div>
    }
    @if (showAvatar) {
      <div class="member-avatar">
        <img [src]="userService.me.imageUrl ?? defaultProfileImage " alt="gravatar">
      </div>
    }
  </div>
</div>
